import { render } from "./TheProfessionalResourcesGrid.vue?vue&type=template&id=7f05d17c&scoped=true&ts=true"
import script from "./TheProfessionalResourcesGrid.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalResourcesGrid.vue?vue&type=script&lang=ts"

import "./TheProfessionalResourcesGrid.vue?vue&type=style&index=0&id=7f05d17c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f05d17c"]])

export default __exports__